import React, { useState, useEffect } from "react";
import "../styles/TeacherDemographicReport.css";
import TeacherProfileNav from "./TeacherProfileNav";
import TeacherStatBox from "./TeacherStatBox"; // Separated the StatBox into a component
// import VideoCard from "./TeacherVideoCard";
import {
  allTeachersViews,
  teacherVideos,
  anavuViews,
} from "../Services/AllServices";
import { getUserID } from "../Storage/Storage"; // VideoCard component to handle individual video rendering
import TeacherManageVideos from "./TeacherManageVideos";

const TeacherDemographicsReport = () => {
  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const [selectedVideo, setSelectedVideo] = useState(null);
  const [totalViews, setTotalViews] = useState(0); // State to hold total views
  const [videosCount, setVideosCount] = useState(0);
  const [totalTagsCount, setTotalTagsCount] = useState(0);
  const [videoData, setVideoData] = useState([]);
  const [anavuViewsCount, setAnavuViews] = useState(0);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const userId = await getUserID(); // Fetch user ID from storage

        // Fetch user profile based on user ID
        const formData = { user_id: userId };

        // Fetch total views for the teacher
        await allTeachersViews(formData, (response) => {
          if (response && response.status === "success") {
            setTotalViews(response.total_views); // Store total views
          }
        });

        await anavuViews(formData, (response) => {
          if (response && response.status === "success") {
            console.log("Anavu Views: ", response);
            setAnavuViews(response.total_views); // Store total views
          } else {
            console.log("No videos yet");
            setAnavuViews(0);
          }
        });

        await teacherVideos(formData, (response) => {
          if (response && response.status === "success") {
            const totalTags = response.data.totalTags;
            const totalTagsCount = Object.keys(totalTags).reduce(
              (acc, key) => acc + totalTags[key],
              0
            );
            setTotalTagsCount(totalTagsCount);
            setVideosCount(response.data.totalVideos);
            // Set totalTagsCount state
            //console.log("Manage Teacher Videos:", response.data);
            if (Array.isArray(response.data.videos_data)) {
              setVideoData(response.data.videos_data);
            } else {
              console.error("Data is not an array:", response);
            }
          }
        });
      } catch (error) {
        console.error("!!!Failed to fetch user profile or total views", error);
      }
    };

    fetchUserProfile();
  }, []);

  return (
    <div className="demographics-report">
      <h1>Demographics Report</h1>
      <div className="user-stats">
        <TeacherStatBox
          title="Number of Videos"
          value={(videosCount || 0).toLocaleString()}
        />
        <TeacherStatBox
          title="Number of Tags"
          value={(totalTagsCount || 0).toLocaleString()}
        />
        <TeacherStatBox
          title="AnaVu views"
          value={(anavuViewsCount || 0).toLocaleString()}
        />
        <TeacherStatBox
          title="Youtube Views"
          value={(totalViews || 0).toLocaleString()}
        />
      </div>
      <TeacherProfileNav />

      <TeacherManageVideos
        videos={videoData}
        // openModal={openModal}
        // isModalOpen={isModalOpen}
        // closeModal={closeModal}
        // removeVideo={removeVideo}
      />
    </div>
  );
};

export default TeacherDemographicsReport;
